import { useEffect } from 'react';

const useClickOutside = (ref, callback, active = true) => {
    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            callback();
        }
    };
    useEffect(() => {
        if (active) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active]); // Re-run the effect when the 'active' value changes
};

export { useClickOutside as default };
//# sourceMappingURL=useClickOutside.js.map
